import React, { FC, ReactElement } from 'react'
import { Button } from 'common/components/Button'
import styles from './styles.module.sass'

interface IGhostButton {
  type?: 'submit' | 'button';
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading?: boolean;
  title?: ReactElement | string;
  icon?: ReactElement;
  iconRight ?: boolean;
  className?: string;
  disabled?: boolean;
  tabIndex?: number;
  hasBorder?: boolean;
}

export const GhostButton: FC<IGhostButton> = ({
  type = 'button',
  onClick,
  isLoading,
  title,
  icon,
  iconRight,
  className,
  disabled,
  tabIndex,
  hasBorder
}) => {
  return (
    <Button
      type={type}
      title={title}
      icon={icon}
      iconRight={iconRight}
      isLoading={isLoading}
      className={`${styles.ghostButton} ${className || ''} ${hasBorder && styles.borderStyles}`}
      disabled={disabled}
      tabIndex={tabIndex}
      onClick={onClick}
    />
  )
}
